import React, { useState } from 'react';

import DirectionDialog from './DirectionsDialog';
import DraggableList from 'components/draggable_list/DraggableList';
import DirectionCard from './direction_card/DirectionCard';
import EditDeleteButtons from 'components/buttons/EditDeleteButtons';

const DirectionsList = ({
  directionUIModels,
  setDirectionUIModels,
  removeDirection,
  editDirection,
}) => {
  const [editedDirection, setEditedDirection] = useState(null);
  const isBeingEdited = !!editedDirection;

  const openEditDialog = (direction) => setEditedDirection(direction);
  const closeEditDialog = () => setEditedDirection(null);

  const _editDirection = (directionText) => {
    editDirection(editedDirection, { ...editedDirection, directionText });
  };

  return (
    <React.Fragment>
      <div style={{ margin: -8 }}>
        <DraggableList
          items={directionUIModels}
          setItems={setDirectionUIModels}
          renderItem={(directionUIModel, isLastItem, isDraggingOver, index) => {
            return (
              <DirectionCard
                directionUIModel={directionUIModel}
                index={index}
                isDraggingOver={isDraggingOver}
                renderButtons={() => {
                  return (
                    <EditDeleteButtons
                      message={
                        <span>
                          Click again to <b>remove</b> this direction
                        </span>
                      }
                      onEditButtonClick={() => openEditDialog(directionUIModel)}
                      onRemoveButtonClick={() =>
                        removeDirection(directionUIModel)
                      }
                    ></EditDeleteButtons>
                  );
                }}
              ></DirectionCard>
            );
          }}
        ></DraggableList>
      </div>
      <DirectionDialog
        open={isBeingEdited}
        onClose={closeEditDialog}
        actionButtonLabel={'EDIT'}
        title={'Edit direction'}
        onActionButtonClick={_editDirection}
        initialDirectionUIModel={editedDirection}
      ></DirectionDialog>
    </React.Fragment>
  );
};

export default DirectionsList;
